export default function getUserFullname(
  showLastNameFirst,
  user = {},
  preferredNamePrecedence = false
) {
  let firstName = preferredNamePrecedence ? user.name : user.legalName;

  // fallback to user.name in case user.legalName was missing
  if (!firstName && user.name) {
    firstName = user.name;
  }

  if (user.lastname) {
    if (showLastNameFirst) {
      return `${user.lastname}, ${firstName}`;
    }

    return `${firstName} ${user.lastname}`;
  }

  return firstName;
}
